<template>
  <div>
    <v-btn @click="$emit('clicked')" color="success">
      <span class="mr-2">Proceed with quotation</span>
      <v-icon>chevron_right</v-icon>
    </v-btn>
    <v-btn @click="$emit('callback')" color="info">
      <v-icon>call</v-icon>
      <span class="mr-2">Request a callback</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ProceedButton"
};
</script>
